export const HAKLAI_ALLOWED_CARD_NUM = "3999";

export const isHaklaiAllowedForCardNum = (belongToCardNum) => (
  String(belongToCardNum || "").trim() === HAKLAI_ALLOWED_CARD_NUM
);
